export const Motif = ({ className = '', variant = 'blue', testId }) => (
  <svg className={`motif ${className} motif-${variant}`} viewBox="0 0 100 100" fill="none" aria-hidden="true" data-testid={testId}>
    {variant === 'blue' ? <>
      <circle cx="50" cy="50" r="45" fill="currentColor" />
      <circle cx="50" cy="50" r="41" stroke="#e8e6d6" strokeWidth="1" />
      {[0, 90, 180, 270].map(r => <g transform={`rotate(${r} 50 50)`} key={r}>
        <path d="M50 48C19 46 24 16 40 23C48 27 49 37 50 48Z" stroke="#e8e6d6" strokeWidth="3.5" />
        <path d="M50 48C47 37 33 29 33 32C36 43 43 46 50 48Z" fill="#e8e6d6" />
      </g>)}
      <circle cx="50" cy="50" r="5" fill="#e8e6d6" />
    </> : <>
      {[0, 60, 120, 180, 240, 300].map(r => <g transform={`rotate(${r} 50 50)`} key={r}>
        <path d="M50 45C32 29 45 20 50 8C55 20 68 29 50 45Z" fill="currentColor" />
        <path d="M50 32V19" stroke="#e8e6d6" strokeWidth="2" />
      </g>)}<circle cx="50" cy="50" r="6" fill="currentColor" />
    </>}
  </svg>
);

export const TextileDivider = () => (
  <div className="textile-divider" aria-hidden="true">
    <div className="textile-medallion"><svg viewBox="0 0 80 80">
      <path d="M25 0H55V13H68V25H80V55H67V68H55V80H25V67H12V55H0V25H13V12H25Z" fill="#e8e6d6" />
      <path d="M30 10H50V22H60V30H70V50H59V60H50V70H30V59H20V50H10V30H21V20H30Z" fill="#a9503b" />
      <path d="M35 22H45V34H57V46H45V58H35V46H23V34H35Z" fill="#4d596f" />
      <circle cx="40" cy="40" r="4" fill="#e8e6d6" />
    </svg></div>
  </div>
);

export const ToolLogo = ({ name }) => {
  if (name === 'figma') return <svg viewBox="0 0 40 60" className="tool-logo" aria-hidden="true">
    <path d="M10 0H20V20H10A10 10 0 0 1 10 0" fill="#f24e1e" /><path d="M20 0H30A10 10 0 0 1 30 20H20Z" fill="#ff7262" />
    <path d="M10 20H20V40H10A10 10 0 0 1 10 20" fill="#a259ff" /><circle cx="30" cy="30" r="10" fill="#1abcfe" />
    <path d="M10 40H20V50A10 10 0 1 1 10 40" fill="#0acf83" />
  </svg>;
  if (name === 'resolve') return <img className="tool-logo resolve-logo" src="/images/refinements/davinci-resolve.webp" width="852" height="852" alt="Official DaVinci Resolve application logo" loading="lazy" data-testid="davinci-official-logo" />;
  return <span className={`adobe-logo ${name}`} aria-hidden="true">{name === 'photoshop' ? 'Ps' : 'Ai'}</span>;
};